<template>
  <div>
    <shipping-table :shippings="shippings" :loading="loading" @reload="load" class="mb-4"/>
  </div>
</template>

<script>
import shippingTable from './shippingTable.vue';
export default {
  components: {
    shippingTable,
  },
  data(){
    return {
      shippings : [],
      loading: true
    }
  },
  created(){
    this.load()
  },
  methods: {
    load(){
      this.$axios.get('api/shippingPrice').then(axRes => {
        this.loading = false;
        this.shippings = axRes.data
      }).catch(axErr => {
        this.showToast(
          this.$t('system.genericError'),
          {
            icon:'fa-warning',
            position: 'bottom-right',
            duration: 10000,
            fullWidth: false,
            className: 'vuestic-toast error'
          },
        )
        this.loading = false;
      })
    }
  }
}
</script>
